import { memo } from "react";

function Icon_Draggable() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="3" width="2" height="2" fill="currentColor" />
      <rect x="5" y="7" width="2" height="2" fill="currentColor" />
      <rect x="5" y="11" width="2" height="2" fill="currentColor" />
      <rect x="9" y="11" width="2" height="2" fill="currentColor" />
      <rect x="9" y="7" width="2" height="2" fill="currentColor" />
      <rect x="9" y="3" width="2" height="2" fill="currentColor" />
    </svg>
  );
}

export default memo(Icon_Draggable);
